import React from 'react';

import Typography from '@material-ui/core/Typography';

import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';

import { makeStyles } from '@material-ui/core/styles';

import {
  riskExistComorbidity,
  noRiskComorbidity,
} from 'on_web/assets/imageList';

import { useTranslation } from 'react-i18next';

import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
  text: {
    fontSize: '20px',
    fontFamily: 'Museo',
    fontWeight: 'bold',
  },
  text2: {
    fontSize: '16px',
    fontFamily: 'Museo',
  },
}));

export default function RiskFactorExplanation(props) {
  const classes = useStyles();

  return (
    <Box px={'20px'} py={'12px'}>
      <Grid container direction="row" justify="flex-start" alignItems="center">
        <Grid item xs={6} sm={6}>
          <Grid item>
            <Box textAlign="center">
              <img
                alt="risk"
                src={
                  props.risk.risk.code === 'age_covid_19_risk'
                    ? props.risk.level > 2
                      ? riskExistComorbidity
                      : noRiskComorbidity
                    : props.risk.level > 0
                    ? riskExistComorbidity
                    : noRiskComorbidity
                }
                width={72}
              />
            </Box>
          </Grid>
          <Grid item>
            <Box textAlign="center" className={classes.text}>
              {props.risk.risk.code === 'age_covid_19_risk'
                ? 'Your age-related risk is ' +
                  props.risk.level_label.toLowerCase()
                : props.risk.level > 0
                ? 'You have this COVID-19 risk factor'
                : 'You do not have this COVID-19 risk factor'}
            </Box>
          </Grid>
        </Grid>
        <Grid item xs={6} sm={6}>
          <Grid
            container
            direction="column"
            justify="center"
            alignItems="flex-end"
          >
            <Box textAlign="center">
              <Typography className={classes.text2}>
                {props.risk.risk.description}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

RiskFactorExplanation.propTypes = {
  risk: PropTypes.shape({
    /**
     * Comorbidity level
     */
    level: PropTypes.number.isRequired,

    /**
     * Label for comorbidity level.
     */
    level_label: PropTypes.string.isRequired,

    risk: PropTypes.shape({
      code: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
    }),
  }),
};
